/**
 * This reducer is used for product search and quick orders
 */
import {
    MORE_GET_PRODUCTS,
    MORE_GET_PRODUCTS_SUCCESS,
    MORE_GET_PRODUCTS_FAILURE,
} from 'src/pages/more/pages/productGuide/redux/action/actionTypes';

const initialState = {
    products: [],
    queryParams: {
        orderType: '',
        pageLimit: 50,
        pageNum: 0,
        searchParam: '',
        searchTerm: '',
        cancelSearchToken: '',
    },
    totalRecordsCount: 0,
    loading: false,
    isBulkUpload: false,
    statusCode: 0,
    statusMessage: '',
};

const searchProductsReducer = (state = initialState, action) => {
    switch (action.type) {
        case MORE_GET_PRODUCTS:
            return {
                ...state,
                queryParams: { ...state.queryParams, ...action.payload },
                loading: true,
                isBulkUpload: false,
            };
        case MORE_GET_PRODUCTS_SUCCESS:
            return {
                ...state,
                products: action.products,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                totalRecordsCount: action.totalRecordsCount,
                loading: false,
                isBulkUpload: false,
            };
        case MORE_GET_PRODUCTS_FAILURE:
            return {
                ...state,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                totalRecordsCount: 0,
                loading: false,
                isBulkUpload: false,
            };

        default: {
            return { ...state };
        }
    }
};

export default searchProductsReducer;
